import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isletmeListesiGetir, isletmeOlustur, isletmeGuncelle, isletmeSil } from '../services/api';
import AdminSablonlar from './AdminSablonlar';

export default function AdminPanel() {
  const navigate = useNavigate();
  const [bolum, setBolum] = useState('ISLETMELER'); // ISLETMELER | SABLONLAR
  const [isletmeler, setIsletmeler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');

  const [modalAcik, setModalAcik] = useState(false);
  const [duzenlenen, setDuzenlenen] = useState(null); // null = yeni, obje = düzenleme
  const [ad, setAd] = useState('');
  const [telefon, setTelefon] = useState('');
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [bitisTarihi, setBitisTarihi] = useState(''); // yyyy-MM-dd (input[type=date] formatı)
  const [olusturHata, setOlusturHata] = useState('');
  const [olusturuluyor, setOlusturuluyor] = useState(false);

  const isoTarih = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

  const listeyiYenile = () => {
    setYukleniyor(true);
    isletmeListesiGetir()
      .then((res) => setIsletmeler(res.data.filter((i) => !i.isSablon)))
      .catch((err) => setHata(err.response?.data?.hata || 'Liste alınamadı.'))
      .finally(() => setYukleniyor(false));
  };

  useEffect(() => {
    if (!localStorage.getItem('adminId')) { navigate('/admin/login'); return; }
    listeyiYenile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const modaliAc = (isletme) => {
    setDuzenlenen(isletme || null);
    setAd(isletme ? isletme.ad : '');
    setTelefon(isletme ? isletme.telefon || '' : '');
    setKullaniciAdi(isletme ? isletme.kullaniciAdi : '');
    setSifre(isletme ? isletme.sifre : '');
    setBitisTarihi(isletme ? isoTarih(new Date(isletme.bitisTarihi)) : '');
    setOlusturHata('');
    setModalAcik(true);
  };

  const bitisTarihineBirYilEkle = () => {
    const mevcut = bitisTarihi ? new Date(bitisTarihi) : new Date();
    mevcut.setFullYear(mevcut.getFullYear() + 1);
    setBitisTarihi(isoTarih(mevcut));
  };

  const isletmeKaydet = (e) => {
    e.preventDefault();
    setOlusturHata(''); setOlusturuluyor(true);
    const dto = { ad, telefon, kullaniciAdi, sifre };
    if (duzenlenen && bitisTarihi) dto.bitisTarihi = bitisTarihi;
    const istek = duzenlenen ? isletmeGuncelle(duzenlenen.id, dto) : isletmeOlustur(dto);
    istek
      .then(() => { setModalAcik(false); listeyiYenile(); })
      .catch((err) => setOlusturHata(err.response?.data?.hata || 'Kaydedilemedi.'))
      .finally(() => setOlusturuluyor(false));
  };

  const [silPopup, setSilPopup] = useState(null); // { isletme, adim: 1|2|3 }
  const [siliniyor, setSiliniyor] = useState(false);
  const [silHata, setSilHata] = useState('');

  const silBaslat = (isletme) => { setSilHata(''); setSilPopup({ isletme, adim: 1 }); };
  const silSonrakiAdim = () => setSilPopup((p) => ({ ...p, adim: p.adim + 1 }));

  const kalicaSil = () => {
    setSiliniyor(true); setSilHata('');
    isletmeSil(silPopup.isletme.id)
      .then(() => { setSilPopup(null); listeyiYenile(); })
      .catch((err) => setSilHata(err.response?.data?.hata || 'Silinemedi.'))
      .finally(() => setSiliniyor(false));
  };

  const cikisYap = () => {
    localStorage.removeItem('adminId');
    localStorage.removeItem('adminKullaniciAdi');
    navigate('/admin/login');
  };

  return (
    <div style={{ maxWidth: 1050, margin: '0 auto', padding: 24 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <h2 style={{ margin: 0, color: '#1e2a3a' }}>Admin Yönetim Paneli</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {bolum === 'ISLETMELER' && <button onClick={() => modaliAc(null)} className="btn btn-vurgu" style={{ whiteSpace: 'nowrap' }}>+ Yeni İşletme Oluştur</button>}
          <button onClick={cikisYap} className="btn btn-koyu" style={{ whiteSpace: 'nowrap' }}>Çıkış</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, borderBottom: '1px solid #e6e6e6' }}>
        {[{ id: 'ISLETMELER', ad: 'İşletmeler' }, { id: 'SABLONLAR', ad: 'Şablonlar' }].map((b) => (
          <button
            key={b.id}
            onClick={() => setBolum(b.id)}
            style={{
              padding: '10px 18px', border: 'none', background: 'none', cursor: 'pointer',
              fontSize: 14, fontWeight: 700, color: bolum === b.id ? '#e8600c' : '#6b7684',
              borderBottom: bolum === b.id ? '3px solid #e8600c' : '3px solid transparent'
            }}
          >
            {b.ad}
          </button>
        ))}
      </div>

      {bolum === 'SABLONLAR' ? (
        <AdminSablonlar />
      ) : (
      <>
      {hata && <div className="hata-kutu">{hata}</div>}

      <div className="kart" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? (
          <div style={{ padding: 20 }}>Yükleniyor...</div>
        ) : isletmeler.length === 0 ? (
          <div style={{ padding: 20, color: '#6b7684' }}>Henüz kayıtlı işletme yok.</div>
        ) : (
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <table className="veri-tablosu" style={{ minWidth: 620 }}>
            <thead>
              <tr>
                <th>İşletme Adı</th>
                <th>Telefon</th>
                <th>Kullanıcı Adı</th>
                <th>Şifre</th>
                <th>Kalan Gün</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {isletmeler.map((i) => (
                <tr key={i.id}>
                  <td style={{ whiteSpace: 'nowrap' }}>{i.ad}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{i.telefon}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <a href={`${process.env.PUBLIC_URL}/${i.slug}`} target="_blank" rel="noreferrer">
                      {i.kullaniciAdi}
                    </a>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{i.sifre}</td>
                  <td style={{ whiteSpace: 'nowrap', color: i.kalanGun <= 30 ? '#c0392b' : '#1e5c30', fontWeight: 700 }}>{i.kalanGun} gün</td>
                  <td style={{ display: 'flex', gap: 8, whiteSpace: 'nowrap' }}>
                    <button onClick={() => modaliAc(i)} className="btn btn-koyu" style={{ padding: '5px 12px', fontSize: 12 }}>Düzenle</button>
                    <button onClick={() => silBaslat(i)} className="btn btn-kirmizi" style={{ padding: '5px 12px', fontSize: 12 }}>Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      {modalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <form onSubmit={isletmeKaydet} className="kart" style={{ width: 400 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <h3 style={{ margin: 0, color: '#1e2a3a' }}>{duzenlenen ? 'İşletmeyi Düzenle' : 'Yeni İşletme Oluştur'}</h3>
              <button type="button" onClick={() => setModalAcik(false)} className="btn btn-koyu">✕</button>
            </div>
            {olusturHata && <div className="hata-kutu">{olusturHata}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {duzenlenen && (
                <div style={{ fontSize: 12, color: '#6b7684' }}>
                  Link: <strong>{process.env.PUBLIC_URL}/{duzenlenen.slug}</strong> (değiştirilemez)
                </div>
              )}
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>İşletme Adı</label>
                <input value={ad} onChange={(e) => setAd(e.target.value)} required />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Telefon</label>
                <input value={telefon} onChange={(e) => setTelefon(e.target.value)} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
                <input value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} required />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
                <input value={sifre} onChange={(e) => setSifre(e.target.value)} required />
              </div>
              {duzenlenen && (
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Lisans Bitiş Tarihi</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input type="date" value={bitisTarihi} onChange={(e) => setBitisTarihi(e.target.value)} style={{ flex: 1 }} />
                    <button type="button" onClick={bitisTarihineBirYilEkle} className="btn btn-koyu" style={{ whiteSpace: 'nowrap' }}>+1 Yıl Ekle</button>
                  </div>
                </div>
              )}
              <button type="submit" disabled={olusturuluyor} className="btn btn-vurgu">
                {olusturuluyor ? 'Kaydediliyor...' : (duzenlenen ? 'Güncelle' : 'Oluştur')}
              </button>
            </div>
          </form>
        </div>
      )}

      {silPopup && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}>
          <div className="kart" style={{ width: 420 }}>
            {silHata && <div className="hata-kutu">{silHata}</div>}

            {silPopup.adim === 1 && (
              <>
                <h3 style={{ marginTop: 0, color: '#1e2a3a' }}>İşletmeyi Sil</h3>
                <p style={{ fontSize: 14 }}><strong>{silPopup.isletme.ad}</strong> işletmesini silmek istediğinize emin misiniz?</p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={silSonrakiAdim} className="btn btn-kirmizi" style={{ flex: 1 }}>Devam Et</button>
                </div>
              </>
            )}

            {silPopup.adim === 2 && (
              <>
                <h3 style={{ marginTop: 0, color: '#c0392b' }}>Bu İşlem Geri Alınamaz</h3>
                <p style={{ fontSize: 14 }}>
                  <strong>{silPopup.isletme.ad}</strong> işletmesine ait TÜM veriler — ürün grupları, ürünler,
                  masalar, garsonlar, siparişler, bildirimler — kalıcı olarak silinecek. Devam etmek istediğinize emin misiniz?
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={silSonrakiAdim} className="btn btn-kirmizi" style={{ flex: 1 }}>Yine de Devam Et</button>
                </div>
              </>
            )}

            {silPopup.adim === 3 && (
              <>
                <h3 style={{ marginTop: 0, color: '#c0392b' }}>Son Onay</h3>
                <p style={{ fontSize: 14 }}>
                  <strong>"{silPopup.isletme.ad}"</strong> işletmesini ve tüm verilerini <strong>kalıcı olarak</strong> silmek
                  üzeresiniz. Bu son onaydır, geri dönüş yoktur.
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setSilPopup(null)} className="btn btn-koyu" style={{ flex: 1 }}>Vazgeç</button>
                  <button onClick={kalicaSil} disabled={siliniyor} className="btn btn-kirmizi" style={{ flex: 1 }}>
                    {siliniyor ? 'Siliniyor...' : 'Evet, Kalıcı Olarak Sil'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      </>
      )}
    </div>
  );
}
